import { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, googleProvider } from "../lib/firebase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleEmailSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (e) {
      setError((e as Error).message);
    }
  };

  const handleGoogleSignIn = async () => {
    setError(null);
    try {
      await signInWithPopup(auth, googleProvider);
      navigate("/");
    } catch (e) {
      setError((e as Error).message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative z-10 px-4">
      <div className="card max-w-sm w-full">
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl mb-1">Thot</h1>
          <p className="text-xs font-mono text-scribe-600 uppercase tracking-widest">
            Coach de certification GenAI
          </p>
        </div>

        <form onSubmit={handleEmailSignIn} className="space-y-4">
          <input
            type="email"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-papyrus-200 bg-papyrus-50 rounded font-sans"
            required
          />
          <input
            type="password"
            placeholder="mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-papyrus-200 bg-papyrus-50 rounded font-sans"
            required
          />
          <button type="submit" className="btn-primary w-full">
            Se connecter
          </button>
        </form>

        <div className="my-4 text-center text-xs text-scribe-600 uppercase">ou</div>

        <button onClick={handleGoogleSignIn} className="btn-secondary w-full">
          Continuer avec Google
        </button>

        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
